import { everyTrue } from 'aa_common/front-end/helpers'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { getAccountingLedger, getDMethod, isPartialImpairment } from 'common/helpers'
import { isEqual } from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAssetItemData } from 'store/asset/selectors'

export const useMaxPartialImpairmentAmount = (bookValue: number) => {
  const asset = useSelector(selectAssetItemData, isEqual)

  return useMemo(() => {
    const assetType = asset?.asset_category?.asset_type
    const accountingLedger = getAccountingLedger(asset?.fixed_asset_ledgers)
    const currentDMethod = accountingLedger?.depreciation_method_code
    const originalDMethod = getDMethod(accountingLedger, true)

    const didImpairment = isPartialImpairment(accountingLedger)

    if (everyTrue(!!bookValue, assetType, !!currentDMethod, !!originalDMethod)) {
      const useResidualForRemaining =
        (!didImpairment &&
          [DEPRECIATION_METHOD_CODE.AVERAGE_USAGE_PERIOD, DEPRECIATION_METHOD_CODE.LEASE_PERIOD_STRAIGHT_LINE].includes(
            currentDMethod!
          )) ||
        (didImpairment && ![DEPRECIATION_METHOD_CODE.NON_DEPRECIABLE].includes(originalDMethod!))

      return (
        bookValue -
        (useResidualForRemaining ? accountingLedger?.residual_amount ?? 0 : accountingLedger?.memorandum_value ?? 0)
      )
    }

    return 0
  }, [bookValue, asset])
}
